import React, { Component } from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm, change} from 'redux-form';

//Material Components
import Grid from '@material-ui/core/Grid';
import validator from 'validator';
import {GeneralAlert} from '../../components/Alert/Alert';

//Engage Componnets
import {renderTextField} from  '../../utils/engageComponents'
import {renderSelect} from  '../../utils/engageComponents'

//Actions
import {AddUser, UpdUser, ConfirmUserAccount} from '../../actions/userAction'
import {getAllCommunities} from '../../actions/communityActions'


    //#region  Redux-form Validate
    const validate = (values) => {
        const errors = {};

        if(!values.userName){
        errors.userName= 'Please enter a name.';
        }

        // if(!values.accountType){
        // errors.accountType= 'Please select an account type.';
        // }

        if(!values.firstName){
        errors.firstName= 'Please enter the fisrt name.';
        }

        if(!values.lastName){
        errors.lastName= 'Please enter the last name.';
        }
        if(!values.email){
            errors.email= 'Please enter email.';
            }

        if(!values.communityName){
        errors.communityName= 'Please select a community name.';
        }

        return errors;
    };
    //#endregion


   //#region  Consts
   const userTypes=[
    {
        accountType: 'superUser',
        name:'Super User'
    },
    {
        accountType:'user',
        name:'User'
    },
   ]
   //#endregion

class AddEditUser extends Component{
    constructor(props){
        super(props)

        this.state={
            //initialData
            _id: (props.data && props.data._id) ? this.props.data._id: undefined, 
            action: (props.data && props.data._id)? 'edit': 'new',
            data: props.data? props.data : undefined,
            keyCloakId: (props.data && props.data.keyCloakId) ? this.props.data.keyCloakId: undefined,
            userData : undefined,
            //UserType
            userTypeSelected: undefined,
            //community
            communitySelected: undefined,
            //Email
            emailText: undefined,
            validEmail: false,
            errorText:undefined,
            openUserTypeCombo: false,
            openCommunityCombo: false,

        }

        
        
        //#region  Redux Form Initial State
        if(props.data){
            
            //USER DATA
            this.props.dispatch(change('UserForm','userName', props.data.userName? props.data.userName: ''));
            this.props.dispatch(change('UserForm','accountType', props.data.accountType? props.data.accountType: ''));
            this.props.dispatch(change('UserForm','firstName', props.data.firstName? props.data.firstName: ''));
            this.props.dispatch(change('UserForm','lastName',  props.data.lastName? props.data.lastName: '' ));
            this.props.dispatch(change('UserForm','email',  props.data.email? props.data.email: '' ));
            this.props.dispatch(change('UserForm','communityName',  props.data.communityName? props.data.communityName: ''  ));
            this.props.dispatch(change('UserForm','keyCloakId',  props.data.keyCloakId? props.data.keyCloakId: ''  ));

        
        } else{
            //USER DATA
            this.props.dispatch(change('UserForm','userName',''));
            this.props.dispatch(change('UserForm','accountType',''));
            this.props.dispatch(change('UserForm','firstName',''));
            this.props.dispatch(change('UserForm','lastName',''));
            this.props.dispatch(change('UserForm','email',''));
            this.props.dispatch(change('UserForm','communityName',''));
            this.props.dispatch(change('UserForm','keyCloakId',''  ));

        }
        //#endregion
        
    };//constructor


    componentDidMount(){
        if(this.state.data){
            (this.state.data.superUser===true)? 
            this.setState({userTypeSelected: userTypes[0]})
            :
            this.setState({userTypeSelected: userTypes[1]})      
        }

        this.props.getAllCommunities();
    };
    
    //#region  Styles
    objStyles={
        titleEngage:{
            color: '#686868',
            fontSize: '20px',
            fontWeight: 'bold',
            textAlign:'left',
        },
        formContainer:{
            width:'100%'
        },
        generailContainer:{
            width:'100%',
            padding:'1rem'
        },
        fieldGrid:{
            marginTop:'1.3rem',
        }
    };
    //#endregion


    //#region  methods
    searchUserType(accountType){
        return userTypes.find((item) => item.accountType === accountType);
    };

    searchcommunityById(communityId){
        if(this.props.communityData){
            return this.props.communityData.find(item => item.communityId === communityId);
        }

        return undefined;
    };

    // clearState(){
    //     this.setState({
    //          //initialData
    //          _id:  undefined, 
    //          action:  'new',
    //          data:  undefined,
    //          userData : undefined,
    //          //UserType
    //         userTypeSelected: undefined,
    //          //community
    //          communitySelected: undefined
    //     });
         
    // }
    //#endregion
   
    //#region Handlers
    onSubmitHandler(formData){
        let objToSend ={...formData}
        let page = 1;
        
        objToSend._id = this.state._id;
        objToSend.active = true;
        
        objToSend.superUser = (this.state.userTypeSelected === userTypes[0])?true:false;
        objToSend.communityId = (this.state.userTypeSelected === userTypes[1] && this.state.communitySelected)? this.state.communitySelected.communityId:'';
        // objToSend.accountType = (this.state.userTypeSelected && this.state.userTypeSelected.accountType)? this.state.userTypeSelected.accountType: 'user';

        let emailError = this.userEmailHandler(objToSend.email); 
        
        if(emailError){
            GeneralAlert('error', emailError);
            return;
        }

        if(this.state._id && this.state._id.length > 0){
            //is Upd
            this.props.UpdUser(this.state._id, objToSend);
            page = this.props.currentPage;
        }else{
            //is Add
           this.props.AddUser(objToSend);
            page = this.props.newItemPage
    
        }

        this.props.closeDialog(page);
    };

    onConfirmHandler(formData){
        let objToSend = {...formData}
        let page = 1;

        if(!objToSend.keyCloakId){
            GeneralAlert('error', 'please enter the keycloakId from user');
            return;
        }

        objToSend._id = this.state.id; 
        objToSend.userStatus = 'completed';

        this.props.ConfirmUserAccount(this.state._id, objToSend);
        page = this.props.currentPage;


        this.props.closeDialog(page);
    };

    userEmailHandler = (emailText) =>{
        let validEmail = validator.isEmail(emailText);
        let errorText = 'error';

        if(emailText && emailText.length > 0){
            if(validEmail){
                errorText = undefined;
            } else{
                return  errorText = 'error in email format';
            }
        } else{
            return errorText='please enter email';
        }

        this.setState({
            emailText: emailText,
            validEmail: validEmail,
            errorText:errorText
        });  

    };
    //#endregion

    //#region Handlers
    
    handleUserTypeCombo=(e,option)=>{
        
        if(!option){
            this.setState((prevState)=>({openUserTypeCombo: !prevState.openUserTypeCombo}));
        } else{
            this.setState({openUserTypeCombo: option});
        }
    }
    handleUserTypeOnBlur=()=>{
        setTimeout(() => {
            this.setState({openUserTypeCombo:false})
        }, 50);
    }

    handleCommunityCombo=(e,option)=>{
        if(!option){
            this.setState((prevState)=>({openCommunityCombo: !prevState.openCommunityCombo}));
        } else{
            this.setState({openCommunityCombo: option});
        }
    }
    handleCommunityOnBlur=()=>{
        setTimeout(() => {
            this.setState({openCommunityCombo:false})
        }, 50);
    }
    //#endregion


   //#endregion
    render(){

        if(this.state.communitySelected === undefined && this.props.data && this.props.communityData && this.state.data.communityId){
            this.setState({communitySelected: this.searchcommunityById(this.props.data.communityId)}) 
        }

        return(
        <div>
            <form>
                <Grid container>
                    <Grid item xs={12}>
                        <div className="imgalignrigth-engage appbtn-details-engage">
                            <div id="save_btn" className="appbtn-engage skybluebtn-engage" onClick={ this.props.handleSubmit(this.onSubmitHandler.bind(this))}>
                                Save
                            </div>
                            <div id="confirm_btn" className="appbtn-engage purplebluebtn-engage" onClick={this.props.handleSubmit(this.onConfirmHandler.bind(this))}>
                                Confirm user
                            </div>
                            <div id="cancel_btn" className="appbtn-engage redbtn-engage" onClick={() => { this.props.closeDialog();}}>
                                Cancel
                            </div>                                   
                        </div>
                    </Grid>
                </Grid>
                <Grid container  style={this.objStyles.generailContainer}>
                    <Grid item xs={12} style={this.objStyles.titleEngage}>Users</Grid>
                    <Grid item container xs={12} style={this.objStyles.formContainer} >
                        <Grid item  xs={12} sm={12} md={6} style={this.objStyles.fieldGrid}>
                            <Field
                                id='Add_user_username'
                                name="userName"
                                label="User"
                                maxLength={20}
                                component={renderTextField}
                                disabled={this.props.data? true : false}
                            />                        
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} style={this.objStyles.fieldGrid}>
                            <Field
                                name="accountType"
                                label="User Type"
                                maxLength={20}
                                selected={this.state.userTypeSelected ? this.state.userTypeSelected: {name:''}  }
                                onChangeHandler={(event, newItem) => {
                                    
                                    this.setState({userTypeSelected :newItem}); 
                                    this.props.dispatch(change('UserForm','accountType', newItem.accountType)); 
                                    this.handleUserTypeCombo(null,false);
                                    
                                }}
                                optionsItemsIconsData= {userTypes? userTypes : [] }
                                component={renderSelect}
                                open={this.state.openUserTypeCombo}
                                onClick={this.handleUserTypeCombo}
                                onBlur={this.handleUserTypeOnBlur}
                                disabled={this.props.data? true : false}
                                idToSet='Add_user_account_type_dropdown'

                            />                      
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} style={this.objStyles.fieldGrid}>
                            <Field

                                name="firstName"
                                label="First Name"
                                maxLength={20}
                                component={renderTextField}
                                disabled={this.props.data? true : false}
                                id='Add_user_firstName'
                            />                        
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} style={this.objStyles.fieldGrid}>
                            <Field

                                name="lastName"
                                label="Last Name"
                                maxLength={20}
                                component={renderTextField}
                                disabled={this.props.data? true : false}
                                id='Add_user_lastName'
                            />                        
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} style={this.objStyles.fieldGrid}>
                            <Field

                                name="email"
                                label="Email"
                                placeholder={'xxx@yyy.zzz'}
                                component={renderTextField}
                                onBlur={(e) => this.userEmailHandler((e && e.target && e.target.value) ? e.target.value : '')}
                                disabled={this.props.data? true : false}
                                id='Add_user_email'
                            />
                        </Grid>
                        {
                            this.props.currentUser === 'superuser' && this.state.data?
                            <Grid item xs={12} sm={12} md={6} style={this.objStyles.fieldGrid}>
                            <Field
                                  name="keyCloakId"
                                  label="keyCloakId"
                                  component={renderTextField}
                                id='Add_user_keyCloakId'
                            />  
                            </Grid>
                            :
                            undefined
                        }
                        {
                            this.state.userTypeSelected === userTypes[1]?
                            <Grid item xs={12} sm={12} md={6} style={this.objStyles.fieldGrid}>
                                <Field
                                    name="communityName"
                                    label="Community"
                                    maxLength={20}
                                    selected={this.state.communitySelected? this.state.communitySelected : {name:''}  }
                                    onChangeHandler={(event, newItem) => { 
                                        
                                        this.setState({communitySelected: newItem});   
                                        this.props.dispatch(change('UserForm','communityName', newItem.communityName  ));
                                        this.handleCommunityCombo(null,false)
                                     }}
                                    optionsItemsIconsData= {this.props.communityData? this.props.communityData : [] }
                                    component={renderSelect}
                                    open={this.state.openCommunityCombo}
                                    onClick={this.handleCommunityCombo}
                                    onBlur={this.handleCommunityOnBlur}
                                    disabled={this.props.data? true : false}
                                    idToSet='Add_user_community_dropdown'
                                />  
                            </Grid>
                            :
                            undefined
                        }
                      
                    </Grid>
                </Grid>
            </form>
        </div>
        );
    }
};


function mapStateToProps(state){
   
    const formData = (state.form && state.form.UserForm && state.form && state.form.UserForm.values )?state.form && state.form.UserForm.values : undefined; 
    const communityData = (state.communityReducer && state.communityReducer.communityData)? state.communityReducer.communityData.map(item =>   ({_id: item._id, communityId: item.communityId,name: item.communityName})) : undefined;
    
    return{
        formData: formData,
        communityData: communityData,
    }
};

export  default connect(mapStateToProps, {AddUser, UpdUser, getAllCommunities, ConfirmUserAccount})(reduxForm({
    form: 'UserForm',
    validate,
    enableReinitialize: true,
})(AddEditUser));